import { Layout } from '@/components/Layout';

export default function FAQ() {
  const faqs = [
    {
      question: 'How do I access your picks?',
      answer: 'All our public picks are available on the homepage. Premium picks and detailed analysis are available through our Stan Store subscription.'
    },
    {
      question: 'How do you calculate your track record?',
      answer: 'We track all published picks with full transparency. Results are updated after games complete and displayed on our Results page. We track wins, losses, pushes, and overall win percentage.'
    },
    {
      question: 'What sports do you cover?',
      answer: 'We primarily focus on NBA and College Basketball, with plans to expand to other major sports based on demand and our analytical edge.'
    },
    {
      question: 'Can I track picks in real-time?',
      answer: 'Yes! Our Live Tracker page shows real-time player statistics during games, allowing you to follow your picks as they happen.'
    },
    {
      question: 'What sportsbooks do you recommend?',
      answer: 'We recommend PrizePicks, Betr, Novig, and Pickit (for tracking). Each offers unique features and competitive lines. Visit our Sportsbooks page for sign-up links and bonuses.'
    },
    {
      question: 'Do you guarantee wins?',
      answer: 'No. Sports betting inherently involves risk, and no one can guarantee wins. We provide data-driven analysis to help inform your decisions, but all bets carry risk.'
    },
    {
      question: 'How often do you post picks?',
      answer: 'We post picks regularly during the NBA and College Basketball seasons. Follow us on social media or enable notifications to stay updated.'
    },
    {
      question: 'Can I get a refund on premium subscriptions?',
      answer: 'Refund policies are managed through Stan Store. Please refer to their terms or contact support for subscription-related questions.'
    },
    {
      question: 'How do I use your affiliate links?',
      answer: 'Click on any sportsbook link from our Sportsbooks page. You\'ll get exclusive sign-up bonuses, and we receive a small commission at no extra cost to you.'
    },
    {
      question: 'Are you licensed gambling advisors?',
      answer: 'No. We provide educational content and statistical analysis. We are not licensed gambling advisors or financial advisors. Always gamble responsibly.'
    }
  ];

  return (
    <Layout>
      <div className="container mx-auto px-6 md:px-12 py-12 max-w-4xl" data-testid="faq-page">
        <h1 className="text-5xl md:text-6xl font-heading font-bold mb-8">FREQUENTLY ASKED QUESTIONS</h1>
        
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-card border border-border p-6" data-testid={`faq-${index}`}>
              <h3 className="text-xl font-heading font-bold mb-3">{faq.question}</h3>
              <p className="text-muted-foreground leading-relaxed">{faq.answer}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-surface-highlight border border-border p-8">
          <h2 className="text-2xl font-heading font-bold mb-4">STILL HAVE QUESTIONS?</h2>
          <p className="text-muted-foreground mb-4">
            If you didn't find what you're looking for, feel free to reach out to us directly.
          </p>
          <a href="/contact" className="text-primary hover:underline font-bold">
            Contact Us →
          </a>
        </div>
      </div>
    </Layout>
  );
}